import {ClientEvent} from '@udemy/event-tracking';

export class LoginSelectEvent extends ClientEvent {
    uiRegion: string;

    constructor(uiRegion: string) {
        super('LoginSelectEvent');
        this.uiRegion = uiRegion;
    }
}
